import _defineProperty from "@babel/runtime/helpers/defineProperty";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { PureComponent } from 'react';
import { toEmojiId } from '../../util/type-helpers';
import { leftClick } from '../../util/mouse';
import { EmojiPreviewComponent } from '../common/EmojiPreviewComponent';
import { typeAheadItem, selected as selectedStyles, typeAheadItemRow, typeaheadSelected } from './styles';
import LegacyEmojiContextProvider from '../../context/LegacyEmojiContextProvider';
export default class EmojiTypeAheadItem extends PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onEmojiSelected", event => {
      const {
        emoji,
        onSelection
      } = this.props;

      if (leftClick(event) && onSelection) {
        event.preventDefault();
        onSelection(toEmojiId(emoji), emoji, event);
      }
    });

    _defineProperty(this, "onEmojiMenuItemMouseMove", event => {
      const {
        emoji,
        onMouseMove
      } = this.props;

      if (onMouseMove) {
        onMouseMove(toEmojiId(emoji), emoji, event);
      }
    });
  }

  render() {
    const {
      selected,
      emoji
    } = this.props;
    const classes = [typeAheadItem, selected && selectedStyles];
    return jsx(LegacyEmojiContextProvider, null, jsx("div", {
      className: `ak-emoji-typeahead-item ${selected ? typeaheadSelected : ''}`,
      css: classes,
      onMouseDown: this.onEmojiSelected,
      onMouseMove: this.onEmojiMenuItemMouseMove,
      "data-emoji-id": emoji.shortName
    }, jsx("div", {
      css: typeAheadItemRow
    }, emoji && jsx(EmojiPreviewComponent, {
      emoji: emoji
    }))));
  }

}